/**
 * 游戏内限时加码相关工具方法
 */

/**
 * 检查商品是否具有游戏内限时加码且在有效期内
 * @param {Object} item - 商品对象，需包含 CP_PRODUCT_EXT.{ INGAME_LIMITED_EXTRA_COIN, LIMITED_EXTRA_END_TIME }
 * @returns {boolean}
 */
export function isIngameLimitedExtraCoinValid(item) {
  const cpProductExt = item?.CP_PRODUCT_EXT || {};
  const endTimeRaw = cpProductExt?.LIMITED_EXTRA_END_TIME;
  if (+cpProductExt?.INGAME_LIMITED_EXTRA_COIN > 0 && +endTimeRaw > 0) {
    const endTimeMs = Number(endTimeRaw) * 1000;
    return Date.now() < endTimeMs;
  }
  return false;
}

/**
 * 获取游戏内限时加码数量（展示用字符串）
 * @param {Object} item - 商品对象
 * @returns {number}
 */
export function getIngameLimitedExtraCoinValue(item) {
  return +item?.CP_PRODUCT_EXT?.INGAME_LIMITED_EXTRA_COIN || 0;
}

/**
 * 获取游戏内限时加码结束时间（毫秒时间戳），无或无效时返回 null
 * @param {Object} item - 商品对象
 * @returns {number|null}
 */
export function getIngameLimitedEndTimeMs(item) {
  const endTimeRaw = item?.CP_PRODUCT_EXT?.LIMITED_EXTRA_END_TIME;
  if (endTimeRaw == null || endTimeRaw === '') {
    return null;
  }
  return Number(endTimeRaw) * 1000;
}
